import React, { useState, useRef } from 'react';
import { Combobox } from '@headlessui/react';

// Every word typed must appear somewhere in the option, so 'sky glass' finds 'NPT GLASS - Sky Blue Glass'
const matchesQuery = (option, query) => {
  const text = option.toLowerCase(); // string
  return query
    .toLowerCase()
    .split(/\s+/)
    .every(word => text.includes(word));
};

const CostBreakdownCombobox = ({ value, placeholder, options = [], onChange, validate = true }) => {
  const [query, setQuery] = useState(''); // string
  const [touched, setTouched] = useState(false); // boolean
  const buttonRef = useRef(null);
  const isError = touched && !value && validate; // boolean
  const filteredOptions = query.trim()
    ? options.filter(option => matchesQuery(option, query.trim()))
    : options; // string[]

  return (
    <Combobox
      as='div'
      className='group w-full'
      value={value}
      onChange={option => {
        setTouched(false);
        setQuery('');
        onChange(option);
      }}
    >
      {({ open }) => (
        <>
          <Combobox.Label className='text-xs text-dark-blue'>{placeholder}</Combobox.Label>
          <div className='relative'>
            <Combobox.Input
              className={`peer mt-0 block w-full pl-3 pr-10 border focus:ring-0 rounded focus:border-black text-dark-blue ${isError ? 'text-red-500 border-red-500' : 'border-black/42'}`}
              displayValue={option => option}
              placeholder='Type to search'
              autoComplete='off'
              onChange={e => setQuery(e.target.value)}
              onClick={() => {
                if (!open) buttonRef.current?.click();
              }}
              onBlur={() => setTouched(true)}
            />
            <Combobox.Button
              ref={buttonRef}
              className='absolute inset-y-0 right-0 flex items-center px-2'
            >
              <svg
                className='h-5 w-5 text-gray-500'
                viewBox='0 0 20 20'
                fill='none'
                aria-hidden='true'
              >
                <path
                  d='m6 8 4 4 4-4'
                  stroke='currentColor'
                  strokeWidth='1.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            </Combobox.Button>
            <Combobox.Options className='absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded border border-black/42 bg-white py-1 shadow-lg'>
              {filteredOptions.length === 0 ? (
                <div className='px-3 py-2 text-dark-blue/60'>No matches</div>
              ) : (
                filteredOptions.map(option => (
                  <Combobox.Option
                    key={option}
                    value={option}
                    className={({ active, selected }) =>
                      `cursor-pointer px-3 py-2 text-dark-blue ${active ? 'bg-navy-bright10' : ''} ${selected ? 'font-semibold' : ''}`
                    }
                  >
                    {option}
                  </Combobox.Option>
                ))
              )}
            </Combobox.Options>
          </div>
        </>
      )}
    </Combobox>
  );
};

export default CostBreakdownCombobox;
